import { render, staticRenderFns } from "./reset-history-modal.component.vue?vue&type=template&id=073098bb&scoped=true&"
import script from "./reset-history-modal.component.vue?vue&type=script&lang=ts&"
export * from "./reset-history-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./reset-history-modal.component.vue?vue&type=style&index=0&id=073098bb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073098bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon})
